import { render, staticRenderFns } from "./AdminProductCategoriesEditScreen.vue?vue&type=template&id=0f196d9e&scoped=true&"
import script from "./AdminProductCategoriesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductCategoriesEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f196d9e",
  null
  
)

export default component.exports